import jdshare from "@jmfe/jm-jdshare";
export default {
  //唤起京东APP
  openJDAPP() {
    const opt = {
      downAppURI:
        "https://wqs.jd.com/downloadApp/downloadAppIOSMPage.html?channel=jd-m",
      downAppIos:
        "https://itunes.apple.com/us/app/jing-dong-wang-gou-shou-dan/id414245413",
      downWeixin:
        "http://a.app.qq.com/o/simple.jsp?pkgname=com.jingdong.app.mall&g_f=991850",
      downIpad: "https://itunes.apple.com/cn/app/jing-dong-hd/id434374726?mt=8",
      inteneUrl: "openApp.jdMobile://virtual?",
      inteneUrlParams: {
        category: "jump",
        des: "getCoupon",
        action: "to",
        url: location.href + "&ad_od=1" + "&event=share",
        landPageId: "mtun"
      },
      M_sourceFrom: "lingquan", //用于看数据用
      openAppEventId: "MDownLoadFloat_OpenNow", //打开客户端EventId，必配
      openAppEventParam: "", //打开客户端EventParam，必配
      NoJumpDownLoadPage: false // 默认唤起失败跳app下载页，若NoJumpDownLoadPage=ture则唤起失败后不会跳下载页k
      // openAppBtnId: buttonId      // 需要注册的按钮id
    };
    window.$.immediateOpenApp(opt);
  },
  random() {
    return ("000000" + Math.floor(Math.random() * 999999)).slice(-6);
  },
  //京东APP内部调用分享功能
  callShare(title, inviteId, shareId, scene = '', openJKL = false) {
    let shareTitle = [
          `我在京东${title.substring(4,title.length - 2)}发现一张力度超大优惠券，速领手慢无`,
          `送你一张${title.substring(4,title.length - 2)}专属优惠券，快点领！慢了就没有了~`
        ]
    const sceneQuery = scene ? `&scene=${scene}` : ''
    const baseShareInfo = {
      title: shareTitle[Math.round(Math.random())],
      content: "京东专属神券免费领，低至5折没有套路~",
      url:
        location.origin +
        location.pathname +
        `?inviteId=` + // /?inviteId=
        inviteId +
        "&shareId=" +
        shareId +
        sceneQuery,
      img:
        "https://img20.360buyimg.com/da/jfs/t1/68546/25/15371/13329/5dcb7c02E461f2992/dcf1c20a035f3c1c.png",
      /**
       * 以下非必填
       */
      channel: "Wxfriends",
      callback: null,
      clickcallback: null,
      timeline_title: ""
    };
    // 京口令配置信息
    const otherShareInfo = openJKL ? {
      keyparam: {
        url:
          location.origin +
          location.pathname +
          `?inviteId=` +
          inviteId +
          "&shareId=" +
          shareId +
          sceneQuery,
        keyEndTime: "1916985466000",
        keyChannel: "Wxfriends",
        sourceCode: "interactshare",
        keyImg:
          "https://img20.360buyimg.com/da/jfs/t1/142385/14/9683/192717/5f743be0Eb1fa6061/5ccc914731743edc.png",
        keyId: inviteId, //活动标识传参规则,详情查看京口令使用规范&调用方式
        keyTitle: shareTitle[Math.round(Math.random())],
        keyContent: "京东专属神券免费领，低至5折没有套路~"
      }
    } : {}
    jdshare.callSharePane({ ...baseShareInfo , ...otherShareInfo});
  }
};
